import { Testimonial } from './types';

export const TESTIMONIALS_DATA: Testimonial[] = [
  {
    id: 0,
    avatar: require('@assets/images/marketplace/quotation-section/anisha.png'),
    quoteKey: 'js.features.marketplace.home.testimonials.testimonial_1.quote',
    nameKey: 'js.features.marketplace.home.testimonials.testimonial_1.name',
    yearsKey: 'js.features.marketplace.home.testimonials.testimonial_1.years',
  },
  {
    id: 1,
    avatar: require('@assets/images/marketplace/quotation-section/jen.svg'),
    quoteKey: 'js.features.marketplace.home.testimonials.testimonial_2.quote',
    nameKey: 'js.features.marketplace.home.testimonials.testimonial_2.name',
    yearsKey: 'js.features.marketplace.home.testimonials.testimonial_2.years',
  },
  {
    id: 2,
    avatar: require('@assets/images/marketplace/quotation-section/dan.svg'),
    quoteKey: 'js.features.marketplace.home.testimonials.testimonial_3.quote',
    nameKey: 'js.features.marketplace.home.testimonials.testimonial_3.name',
    yearsKey: 'js.features.marketplace.home.testimonials.testimonial_3.years',
  },
  {
    id: 3,
    avatar: require('@assets/images/marketplace/quotation-section/goran.png'),
    quoteKey: 'js.features.marketplace.home.testimonials.testimonial_4.quote',
    nameKey: 'js.features.marketplace.home.testimonials.testimonial_4.name',
    yearsKey: 'js.features.marketplace.home.testimonials.testimonial_4.years',
  },
  {
    id: 4,
    avatar: require('@assets/images/marketplace/quotation-section/josefien.svg'),
    quoteKey: 'js.features.marketplace.home.testimonials.testimonial_5.quote',
    nameKey: 'js.features.marketplace.home.testimonials.testimonial_5.name',
    yearsKey: 'js.features.marketplace.home.testimonials.testimonial_5.years',
  },
  {
    id: 5,
    avatar: require('@assets/images/marketplace/quotation-section/chiran.png'),
    quoteKey: 'js.features.marketplace.home.testimonials.testimonial_6.quote',
    nameKey: 'js.features.marketplace.home.testimonials.testimonial_6.name',
    yearsKey: 'js.features.marketplace.home.testimonials.testimonial_6.years',
  },
];
